import { createElement } from 'react';
import { has, isEmpty, isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { usePopups } from '../../usePopups';

const checkIsTopModal = (stack, type) => stack[0] === type;

const propTypes = {
  registeredPopupsMap: PropTypes.instanceOf(Map).isRequired,
  activePopupsMap: PropTypes.instanceOf(Map).isRequired,
  stack: PropTypes.array.isRequired,
};

export const CommonPopup = ({ registeredPopupsMap, activePopupsMap, stack }) => {
  const popups = usePopups();

  return [...activePopupsMap.entries()].map(([popupName, popupState]) => {
    if (isEmpty(popupState)) {
      return null;
    }

    const { popupProps } = popupState;

    const handleClose = (...args) => {
      // Mark popup as 'closed' in service data
      popups.closePopup(popupName);

      // If popup has 'onClose' handler - call it
      if (has(popupProps, 'onClose') && isFunction(popupProps.onClose)) {
        popupProps.onClose(...args);
      }
    };

    // If popup is transient, then we do not render it in closed state
    if (!popupState.open) {
      return null;
    }

    const popupComponent = registeredPopupsMap.get(popupName);
    if (!popupComponent) {
      return null;
    }

    return createElement(popupComponent, {
      key: popupState.key,
      ...popupProps,
      open: popupState.open,
      onClose: handleClose,

      isTopModal: checkIsTopModal(stack, popupName),
    });
  });
};

CommonPopup.propTypes = propTypes;
